module.exports = __webpack_public_path__ + "assets-cabinet/img/group-4.d7f4fab7.svg";